import hasJswJsd from '@atlassian/jira-common-has-jsw-jsd/src/index.tsx';
import isJswJsdBundle from '@atlassian/jira-common-is-jsw-jsd-bundle/src/index.tsx';
import { getFirstActivationDate } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import FireEngagementTargetingEvents from './main.tsx';
import hasJswConfluence from './utils/has-jsw-confluence/index.tsx';
import isJswPrimaryIntentConfluenceBundle from './utils/is-jsw-primary-intent-confluence-bundle/index.tsx';

export default withInjectedProps(FireEngagementTargetingEvents, {
	onJswJsdBundleCheck: () => hasJswJsd() && isJswJsdBundle(),
	onJswConfluenceBundleCheck: () => hasJswConfluence() && isJswPrimaryIntentConfluenceBundle(),
	onGetFirstActivationDate: () => getFirstActivationDate(),
});
